goog.provide("shadow.js.shim.module$react_useportal$default");
shadow.js.shim.module$react_useportal$default = shadow.js.require(114, {}).default;
